<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import Icon from 'fa-svelte'
    import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'

    import Select from './Select.svelte'
    import Text from './Text.svelte'
    import TextArea from './TextArea.svelte'
    import File from './File.svelte'
    import Date from './Date.svelte'
    import MultipleSelect from './MultipleSelect.svelte'
    import Btn from './Button.svelte'

    const FIELD_MAP = {
        'Text': Text,
        'Text Area': TextArea,
        'Single choice': Select,
        'Multiple choice': MultipleSelect,
        'File': File,
        'Date': Date,
    }

    export let value
    export let field

    const dispatch = createEventDispatcher();

    onMount(() => { if (!value) value = [{ }] });

    const handleRemoveClick = groupIndex => {
        value = value.filter((group, index) => index !== groupIndex)
        dispatch('remove', value);
        dispatch('change', value);
    }

    const handleAddClick = () => {
        value = [...value, { }];
        dispatch('add', value);
        dispatch('change', value);
    }

    const handleChange = () => dispatch('change', value);
</script>


<div class="repeatable-group-field">
    {#if value && value.length}
        {#each value as group, groupIndex}
            <div class="group">
                {#each field.values as subField}
                    <div>
                        <div>{ subField.title }</div>
                        <svelte:component
                            bind:value={group[subField.key]}
                            on:change={handleChange}
                            this={FIELD_MAP[subField.type]}
                            field={subField}
                        />
                    </div>
                {/each}

                {#if groupIndex !== 0}
                    <div class="delete-wrapper">
                        <Btn size="mini" type="danger" on:click={() => handleRemoveClick(groupIndex)}>
                            <Icon icon={faTrash}/> &nbsp;Delete
                        </Btn>
                    </div>
                {/if}
            </div>
        {/each}
    {/if}

    <Btn size="mini" on:click={handleAddClick}>+ Another { field.title }</Btn>
</div>

<style>
    .repeatable-group-field {

    }

    .group {
        padding: 10px;
        border-radius: 5px;
        background: rgba(0, 0, 0, .05);
        margin-bottom: 20px;
    }

    .delete-wrapper {
        display: flex;
        justify-content: flex-end;
    }
</style>
